import { z } from 'zod';
import { CalEventFieldType } from '../constants/cal-event-field-type.js';
import { CAL_EVENT_FIELD_PHASES } from './cal-event-field-phases.js';
import { CAL_EVENT_GRACE_HOURS } from './cal-event-grace-hours.js';
import { CAL_EVENT_TEMPLATE_TEXT_MAX_LENGTH } from './cal-event-template-text-max-length.js';
import { MISSED_REQUIREMENT_ACTION_NAMES } from './missed-requirement-action-names.js';
import { selectOptionKey } from './select-option-key.js';
import { TEMPLATE_ENTITY_REF_KINDS } from './template-entity-ref-kinds.js';
import { TEMPLATE_NUMBER_LIMIT } from './template-number-limit.js';
const baseConfig = {
    required: z.boolean().optional(),
    phase: z.enum(CAL_EVENT_FIELD_PHASES).optional(),
    onMiss: z.enum(MISSED_REQUIREMENT_ACTION_NAMES).optional(),
    graceHours: z
        .number()
        .int('Grace period must be a whole number of hours.')
        .min(0, 'Grace period cannot be negative.')
        .max(CAL_EVENT_GRACE_HOURS.max, `Grace period must be ${CAL_EVENT_GRACE_HOURS.max} hours or fewer.`)
        .optional(),
};
const textConfigSchema = z.strictObject({
    ...baseConfig,
    multiline: z.boolean().optional(),
    maxLength: z.number().int().min(1).max(CAL_EVENT_TEMPLATE_TEXT_MAX_LENGTH).optional(),
});
const numberConfigSchema = z
    .strictObject({
    ...baseConfig,
    min: z
        .number()
        .gt(-TEMPLATE_NUMBER_LIMIT, 'Minimum is too small.')
        .lt(TEMPLATE_NUMBER_LIMIT, 'Minimum is too large.')
        .optional(),
    max: z
        .number()
        .gt(-TEMPLATE_NUMBER_LIMIT, 'Maximum is too small.')
        .lt(TEMPLATE_NUMBER_LIMIT, 'Maximum is too large.')
        .optional(),
    integer: z.boolean().optional(),
    currency: z.boolean().optional(),
})
    .refine((config) => !(config.currency && config.integer), {
    message: 'A dollar amount cannot be whole numbers only.',
    path: ['integer'],
})
    .refine((config) => config.min === undefined || config.max === undefined || config.min <= config.max, {
    message: 'Minimum must be less than or equal to maximum.',
    path: ['max'],
});
const dateConfigSchema = z.strictObject(baseConfig);
const selectConfigSchema = z.strictObject({
    ...baseConfig,
    options: z
        .array(z
        .string()
        .trim()
        .min(1, 'Option cannot be blank.')
        .max(128, 'Option must be 128 characters or fewer.'))
        .min(1, 'Add at least one option.')
        .max(100, 'A select field can have at most 100 options.')
        .refine((options) => new Set(options.map(selectOptionKey)).size === options.length, 'Options must be unique, ignoring case.'),
});
const entityRefConfigSchema = z.strictObject({
    ...baseConfig,
    entity: z.enum(TEMPLATE_ENTITY_REF_KINDS, { error: 'Choose what this field references.' }),
});
const perProductNumberConfigSchema = z.strictObject(baseConfig);
export const TEMPLATE_FIELD_CONFIG_SCHEMAS = {
    [CalEventFieldType.TEXT]: textConfigSchema,
    [CalEventFieldType.NUMBER]: numberConfigSchema,
    [CalEventFieldType.DATE]: dateConfigSchema,
    [CalEventFieldType.SELECT]: selectConfigSchema,
    [CalEventFieldType.ENTITY_REF]: entityRefConfigSchema,
    [CalEventFieldType.PER_PRODUCT_NUMBER]: perProductNumberConfigSchema,
};
//# sourceMappingURL=template-field-config.js.map